import gsap from 'gsap';

import { qs, getRandom } from '@/scripts/utils';


class Marquee {
  constructor(el, colors) {
    this.el = el;
    this.settings = {
      horizontal: true,
      vertical: true,
      speed: 300,
      container: this.el.parentNode,
    };
    this.colors = colors;
    this.tempColor = null;
    this.containerWidth = this.settings.container.offsetWidth;
    this.containerHeight = this.settings.container.offsetHeight;
    this.elWidth = this.el.offsetWidth;
    this.elHeight = this.el.offsetHeight;
    this.bumpEdge = () => {
      let rand = getRandom(0, this.colors.length - 1);
      let increment = (rand === this.colors.length - 1 ? -  1 : + 1);
      let newColor = this.colors[rand];
      if(newColor === this.tempColor ) {
        newColor = this.colors[rand + increment];
      }
      gsap.to(qs('.logo', this.el), 0.5, {
        fill: newColor,
        ease: gsap.Expo.easeOut,
      });
      this.tempColor = newColor;
    };
    this.bumpEdge();
  }

  init() {
    this.getSizes();

    gsap.set(this.el, {
      autoAlpha: 1,
      left: 0,
      top: 0,
      x: (this.elWidth / -2),
      y: (this.elHeight / -2),
    });

    if (this.settings.horizontal) {
      this.right();
    }
    if (this.settings.vertical) {
      this.down();
    }

    window.addEventListener('resize', this.getSizes.bind(this));
  }

  getSizes() {
    this.containerWidth = this.settings.container.offsetWidth;
    this.containerHeight = this.settings.container.offsetHeight;
    this.elWidth = this.el.offsetWidth;
    this.elHeight = this.el.offsetHeight;
  }

  right() {
    gsap.to(this.el, this.containerWidth / this.settings.speed, {
      x: this.containerWidth - this.elWidth,
      ease: gsap.Power0.easeNone,
      onComplete: () => {
        this.bumpEdge();
        this.left();
      },
    });
  }

  left() {
    gsap.to(this.el, this.containerWidth / this.settings.speed, {
      x: 0,
      ease: gsap.Power0.easeNone,
      onComplete: () => {
        this.bumpEdge();
        this.right();
      },
    });
  }

  down() {
    gsap.to(this.el, this.containerHeight / this.settings.speed, {
      y: this.containerHeight - this.elHeight,
      ease: gsap.Power0.easeNone,
      onComplete: () => {
        this.bumpEdge();
        this.up();
      },
    });
  }

  up() {
    gsap.to(this.el, this.containerHeight / this.settings.speed, {
      y: 0,
      ease: gsap.Power0.easeNone,
      onComplete: () => {
        this.bumpEdge();
        this.down();
      },
    });
  }

  destroy() {
    gsap.set(this.el, { autoAlpha: 0 });

    window.removeEventListener('resize', this.getSizes.bind(this));
  }
}

export default Marquee;


// WEBPACK FOOTER //
// ./src/scripts/marquee.js